import { render, staticRenderFns } from "./ApproveReject.vue?vue&type=template&id=1a8f9121"
import script from "./ApproveReject.vue?vue&type=script&lang=js"
export * from "./ApproveReject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports